var cov_20elz13h4m = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tooltip/Container.tsx",
      hash = "05f89f5a427f60409d6c6db264b756f997d2a76f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tooltip/Container.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 42
        },
        end: {
          line: 16,
          column: 49
        }
      },
      "2": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 18
        }
      },
      "3": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 50
        }
      },
      "4": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 56
        }
      },
      "5": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 44
        }
      },
      "6": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "7": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 27
        }
      },
      "8": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 46
        }
      },
      "9": {
        start: {
          line: 38,
          column: 40
        },
        end: {
          line: 38,
          column: 46
        }
      },
      "10": {
        start: {
          line: 40,
          column: 40
        },
        end: {
          line: 40,
          column: 50
        }
      },
      "11": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "12": {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 42,
          column: 38
        }
      },
      "13": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 26
        }
      },
      "14": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 22
        }
      },
      "15": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 12
        }
      },
      "16": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 63
        }
      },
      "17": {
        start: {
          line: 57,
          column: 51
        },
        end: {
          line: 57,
          column: 61
        }
      },
      "18": {
        start: {
          line: 58,
          column: 17
        },
        end: {
          line: 58,
          column: 34
        }
      },
      "19": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "20": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "21": {
        start: {
          line: 67,
          column: 32
        },
        end: {
          line: 67,
          column: 42
        }
      },
      "22": {
        start: {
          line: 68,
          column: 19
        },
        end: {
          line: 68,
          column: 60
        }
      },
      "23": {
        start: {
          line: 69,
          column: 25
        },
        end: {
          line: 71,
          column: 50
        }
      },
      "24": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 80,
          column: 7
        }
      },
      "25": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 14
        }
      },
      "26": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 54
        }
      },
      "27": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 54
        }
      },
      "28": {
        start: {
          line: 85,
          column: 24
        },
        end: {
          line: 85,
          column: 34
        }
      },
      "29": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 92,
          column: 7
        }
      },
      "30": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 23
        }
      },
      "31": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 91,
          column: 17
        }
      },
      "32": {
        start: {
          line: 90,
          column: 10
        },
        end: {
          line: 90,
          column: 25
        }
      },
      "33": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 34
        }
      },
      "34": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 12
        }
      },
      "35": {
        start: {
          line: 101,
          column: 18
        },
        end: {
          line: 101,
          column: 36
        }
      },
      "36": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 109,
          column: 7
        }
      },
      "37": {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 30
        }
      },
      "38": {
        start: {
          line: 106,
          column: 10
        },
        end: {
          line: 106,
          column: 21
        }
      },
      "39": {
        start: {
          line: 110,
          column: 20
        },
        end: {
          line: 110,
          column: 60
        }
      },
      "40": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "41": {
        start: {
          line: 115,
          column: 56
        },
        end: {
          line: 115,
          column: 66
        }
      },
      "42": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 120,
          column: 7
        }
      },
      "43": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 82
        }
      },
      "44": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 19
        }
      },
      "45": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 31
        }
      },
      "46": {
        start: {
          line: 122,
          column: 16
        },
        end: {
          line: 122,
          column: 31
        }
      },
      "47": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 130,
          column: 7
        }
      },
      "48": {
        start: {
          line: 132,
          column: 32
        },
        end: {
          line: 132,
          column: 45
        }
      },
      "49": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 142,
          column: 7
        }
      },
      "50": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 44
        }
      },
      "51": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 47
        }
      },
      "52": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 141,
          column: 9
        }
      },
      "53": {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "54": {
        start: {
          line: 138,
          column: 17
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "55": {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 41
        }
      },
      "56": {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 62
        }
      },
      "57": {
        start: {
          line: 140,
          column: 38
        },
        end: {
          line: 140,
          column: 62
        }
      },
      "58": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 86
        }
      },
      "59": {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 148,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 15
          },
          end: {
            line: 15,
            column: 16
          }
        },
        loc: {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 149,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        loc: {
          start: {
            line: 27,
            column: 39
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        loc: {
          start: {
            line: 37,
            column: 50
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        },
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 17
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        loc: {
          start: {
            line: 56,
            column: 18
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 56
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        loc: {
          start: {
            line: 62,
            column: 32
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 62
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        loc: {
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 66
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        loc: {
          start: {
            line: 83,
            column: 17
          },
          end: {
            line: 93,
            column: 5
          }
        },
        line: 83
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 89,
            column: 36
          },
          end: {
            line: 89,
            column: 37
          }
        },
        loc: {
          start: {
            line: 89,
            column: 42
          },
          end: {
            line: 91,
            column: 9
          }
        },
        line: 89
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        loc: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 98,
            column: 5
          }
        },
        line: 95
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        loc: {
          start: {
            line: 100,
            column: 15
          },
          end: {
            line: 112,
            column: 5
          }
        },
        line: 100
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        },
        loc: {
          start: {
            line: 104,
            column: 38
          },
          end: {
            line: 107,
            column: 9
          }
        },
        line: 104
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        },
        loc: {
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 145,
            column: 5
          }
        },
        line: 114
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 137,
            column: 24
          },
          end: {
            line: 137,
            column: 25
          }
        },
        loc: {
          start: {
            line: 137,
            column: 38
          },
          end: {
            line: 141,
            column: 9
          }
        },
        line: 137
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 46
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 46
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 15
          }
        }, {
          start: {
            line: 38,
            column: 19
          },
          end: {
            line: 38,
            column: 38
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 45
          }
        }, {
          start: {
            line: 41,
            column: 49
          },
          end: {
            line: 41,
            column: 82
          }
        }],
        line: 41
      },
      "4": {
        loc: {
          start: {
            line: 57,
            column: 14
          },
          end: {
            line: 57,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 25
          },
          end: {
            line: 57,
            column: 46
          }
        }],
        line: 57
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 25
          },
          end: {
            line: 71,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 47
          }
        }, {
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 50
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        }, {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        }],
        line: 73
      },
      "7": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 77,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 36
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 36
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 36
          }
        }, {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 36
          }
        }],
        line: 74
      },
      "8": {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 54
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 54
          }
        }],
        line: 84
      },
      "9": {
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        }, {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        }],
        line: 86
      },
      "10": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }, {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }],
        line: 117
      },
      "11": {
        loc: {
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 31
          }
        }, {
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 31
          }
        }],
        line: 122
      },
      "12": {
        loc: {
          start: {
            line: 124,
            column: 20
          },
          end: {
            line: 130,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 127,
            column: 15
          }
        }, {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 16
          }
        }],
        line: 124
      },
      "13": {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }, {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }],
        line: 133
      },
      "14": {
        loc: {
          start: {
            line: 138,
            column: 10
          },
          end: {
            line: 138,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 10
          },
          end: {
            line: 138,
            column: 36
          }
        }, {
          start: {
            line: 138,
            column: 10
          },
          end: {
            line: 138,
            column: 36
          }
        }],
        line: 138
      },
      "15": {
        loc: {
          start: {
            line: 140,
            column: 10
          },
          end: {
            line: 140,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 10
          },
          end: {
            line: 140,
            column: 62
          }
        }, {
          start: {
            line: 140,
            column: 10
          },
          end: {
            line: 140,
            column: 62
          }
        }],
        line: 140
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tooltip/Container.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement, isValidElement } from 'react';
import { tooltipClass } from './styles';
import { scrollConsumer } from '../Scroll/context';
import { getUidStr } from '../utils/uid';
import { getPosition as _getPosition } from '../utils/dom/popover';
var DefaultProps = (cov_20elz13h4m.s[0]++, {
  animation: true,
  delay: 0,
  position: 'top',
  trigger: 'hover'
});
export default function (options) {
  cov_20elz13h4m.f[0]++;

  var _ref = (cov_20elz13h4m.s[1]++, options),
      show = _ref.show,
      hide = _ref.hide,
      move = _ref.move,
      isCurrent = _ref.isCurrent;

  var Container =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Container, _PureComponent);

    var _super = _createSuper2(Container);

    function Container(props) {
      var _this;

      _classCallCheck(this, Container);

      cov_20elz13h4m.f[1]++;
      cov_20elz13h4m.s[2]++;
      _this = _super.call(this, props);
      _this.id = void 0;
      _this.placeholderElement = void 0;
      _this.showTimer = void 0;
      cov_20elz13h4m.s[3]++;
      _this.handleShow = _this.handleShow.bind(_assertThisInitialized(_this));
      cov_20elz13h4m.s[4]++;
      _this.handleDismiss = _this.handleDismiss.bind(_assertThisInitialized(_this));
      cov_20elz13h4m.s[5]++;
      _this.tryHide = _this.tryHide.bind(_assertThisInitialized(_this));
      cov_20elz13h4m.s[6]++;
      _this.elementRef = _this.elementRef.bind(_assertThisInitialized(_this));
      cov_20elz13h4m.s[7]++;
      _this.id = getUidStr();
      return _this;
    }

    _createClass(Container, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_20elz13h4m.f[2]++;
        cov_20elz13h4m.s[8]++;

        if ((cov_20elz13h4m.b[1][0]++, !move) || (cov_20elz13h4m.b[1][1]++, !isCurrent(this.id))) {
          cov_20elz13h4m.b[0][0]++;
          cov_20elz13h4m.s[9]++;
          return;
        } else {
          cov_20elz13h4m.b[0][1]++;
        }

        var _ref2 = (cov_20elz13h4m.s[10]++, this.props),
            scrollLeft = _ref2.scrollLeft,
            scrollTop = _ref2.scrollTop;

        cov_20elz13h4m.s[11]++;

        if ((cov_20elz13h4m.b[3][0]++, prevProps.scrollLeft !== scrollLeft) || (cov_20elz13h4m.b[3][1]++, prevProps.scrollTop !== scrollTop)) {
          cov_20elz13h4m.b[2][0]++;
          var pos = (cov_20elz13h4m.s[12]++, this.getPosition());
          cov_20elz13h4m.s[13]++;
          move(this.id, pos);
          cov_20elz13h4m.s[14]++;
          this.tryHide();
        } else {
          cov_20elz13h4m.b[2][1]++;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_20elz13h4m.f[3]++;
        cov_20elz13h4m.s[15]++;
        hide();
      }
    }, {
      key: "getElement",
      value: function getElement() {
        cov_20elz13h4m.f[4]++;
        cov_20elz13h4m.s[16]++;
        return this.placeholderElement.nextSibling;
      }
    }, {
      key: "getPosition",
      value: function getPosition() {
        cov_20elz13h4m.f[5]++;

        var _ref3 = (cov_20elz13h4m.s[17]++, this.props),
            _ref3$position = _ref3.position,
            position = _ref3$position === void 0 ? (cov_20elz13h4m.b[4][0]++, DefaultProps.position) : _ref3$position;

        var el = (cov_20elz13h4m.s[18]++, this.getElement());
        cov_20elz13h4m.s[19]++;
        return _getPosition(position, el);
      }
    }, {
      key: "elementRef",
      value: function elementRef(el) {
        cov_20elz13h4m.f[6]++;
        cov_20elz13h4m.s[20]++;
        this.placeholderElement = el;
      }
    }, {
      key: "tryHide",
      value: function tryHide() {
        cov_20elz13h4m.f[7]++;

        var _ref4 = (cov_20elz13h4m.s[21]++, this.props),
            scrollElement = _ref4.scrollElement;

        var rect = (cov_20elz13h4m.s[22]++, this.getElement().getBoundingClientRect());
        var scrollRect = (cov_20elz13h4m.s[23]++, scrollElement ? (cov_20elz13h4m.b[5][0]++, scrollElement.getBoundingClientRect()) : (cov_20elz13h4m.b[5][1]++, {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }));
        cov_20elz13h4m.s[24]++;

        if ((cov_20elz13h4m.b[7][0]++, rect.bottom < scrollRect.top) || (cov_20elz13h4m.b[7][1]++, rect.top > scrollRect.bottom) || (cov_20elz13h4m.b[7][2]++, rect.right < scrollRect.left) || (cov_20elz13h4m.b[7][3]++, rect.left > scrollRect.right)) {
          cov_20elz13h4m.b[6][0]++;
          cov_20elz13h4m.s[25]++;
          hide();
        } else {
          cov_20elz13h4m.b[6][1]++;
        }
      }
    }, {
      key: "handleShow",
      value: function handleShow() {
        var _this2 = this;

        cov_20elz13h4m.f[8]++;
        cov_20elz13h4m.s[26]++;

        if (this.showTimer) {
          cov_20elz13h4m.b[8][0]++;
          cov_20elz13h4m.s[27]++;
          clearTimeout(this.showTimer);
        } else {
          cov_20elz13h4m.b[8][1]++;
        }

        var _ref5 = (cov_20elz13h4m.s[28]++, this.props),
            delay = _ref5.delay;

        cov_20elz13h4m.s[29]++;

        if (!delay) {
          cov_20elz13h4m.b[9][0]++;
          cov_20elz13h4m.s[30]++;
          this.showSync();
        } else {
          cov_20elz13h4m.b[9][1]++;
          cov_20elz13h4m.s[31]++;
          this.showTimer = setTimeout(function () {
            cov_20elz13h4m.f[9]++;
            cov_20elz13h4m.s[32]++;

            _this2.showSync();
          }, delay);
        }
      }
    }, {
      key: "handleDismiss",
      value: function handleDismiss() {
        cov_20elz13h4m.f[10]++;
        cov_20elz13h4m.s[33]++;
        clearTimeout(this.showTimer);
        cov_20elz13h4m.s[34]++;
        hide();
      }
    }, {
      key: "showSync",
      value: function showSync() {
        cov_20elz13h4m.f[11]++;
        var pos = (cov_20elz13h4m.s[35]++, this.getPosition());
        var style = (cov_20elz13h4m.s[36]++, Object.keys(pos).reduce(function (data, key) {
          cov_20elz13h4m.f[12]++;
          cov_20elz13h4m.s[37]++;
          data[key] = pos[key];
          cov_20elz13h4m.s[38]++;
          return data;
        }, {}));
        var props = (cov_20elz13h4m.s[39]++, Object.assign({}, this.props, {
          style: style
        }));
        cov_20elz13h4m.s[40]++;
        show(props, this.id, this.props.style);
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        cov_20elz13h4m.f[13]++;

        var _ref6 = (cov_20elz13h4m.s[41]++, this.props),
            children = _ref6.children,
            trigger = _ref6.trigger,
            disabledChild = _ref6.disabledChild,
            tip = _ref6.tip;

        cov_20elz13h4m.s[42]++;

        if (!
        /*#__PURE__*/
        isValidElement(children)) {
          cov_20elz13h4m.b[10][0]++;
          cov_20elz13h4m.s[43]++;
          console.error(new Error('Tooltip children expect a single ReactElement.'));
          cov_20elz13h4m.s[44]++;
          return null;
        } else {
          cov_20elz13h4m.b[10][1]++;
        }

        cov_20elz13h4m.s[45]++;

        if (!tip) {
          cov_20elz13h4m.b[11][0]++;
          cov_20elz13h4m.s[46]++;
          return children;
        } else {
          cov_20elz13h4m.b[11][1]++;
        }

        var inner = (cov_20elz13h4m.s[47]++, disabledChild ? (cov_20elz13h4m.b[12][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: tooltipClass('disabled-wrapper'),
          style: {
            cursor: 'not-allowed'
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 125,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        cloneElement(children, {
          style: _objectSpread2(_objectSpread2({}, children.props.style), {}, {
            pointerEvents: 'none'
          })
        }))) : (cov_20elz13h4m.b[12][1]++, children));
        var props = (cov_20elz13h4m.s[48]++, {
          key: 'el'
        });
        cov_20elz13h4m.s[49]++;

        if (trigger === 'hover') {
          cov_20elz13h4m.b[13][0]++;
          cov_20elz13h4m.s[50]++;
          props.onMouseEnter = this.handleShow;
          cov_20elz13h4m.s[51]++;
          props.onMouseLeave = this.handleDismiss;
        } else {
          cov_20elz13h4m.b[13][1]++;
          cov_20elz13h4m.s[52]++;

          props.onClick = function (e) {
            cov_20elz13h4m.f[14]++;
            cov_20elz13h4m.s[53]++;

            if (e) {
              cov_20elz13h4m.b[14][0]++;
              cov_20elz13h4m.s[54]++;
              e.stopPropagation();
            } else {
              cov_20elz13h4m.b[14][1]++;
            }

            cov_20elz13h4m.s[55]++;
            setTimeout(_this3.handleShow, 10);
            cov_20elz13h4m.s[56]++;

            if (children.props.onClick) {
              cov_20elz13h4m.b[15][0]++;
              cov_20elz13h4m.s[57]++;
              children.props.onClick();
            } else {
              cov_20elz13h4m.b[15][1]++;
            }
          };
        }

        cov_20elz13h4m.s[58]++;
        return [
        /*#__PURE__*/
        React.createElement("noscript", {
          ref: this.elementRef,
          key: "ns",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 15
          }
        }),
        /*#__PURE__*/
        cloneElement(inner, props)];
      }
    }]);

    return Container;
  }(PureComponent);

  Container.defaultProps = DefaultProps;
  cov_20elz13h4m.s[59]++;
  return scrollConsumer(Container);
}